import React from 'react';
import { useRouter } from 'next/router';
import { dataLayerPush } from '@chotot/web-gtm';
import dynamic from 'next/dynamic';
import { useSendOTP } from '~/apis/auth';

const MessageDialog = dynamic(() => import('../common/MessageDialog'));

type Props = {
  open?: boolean;
  onClose?: () => void;
  data: {
    modal_header: string;
    modal_body: string;
    modal_button_text: string;
  } | null;
  phone: string;
};

const VerifyOTPPopup = (props: Props) => {
  const { open, onClose, data, phone } = props;
  const { query, push } = useRouter();

  const { fetch: sendOTP } = useSendOTP();

  const goVerifyOTP = () => {
    dataLayerPush({
      event: 'track_event',
      event_category: 'login',
      event_action: 'click',
      event_label: 'login_w_otp',
    });

    sendOTP(phone, 'mfa');
    push(
      `/login/otp?phone=${phone}&continue=${
        query.continue ? encodeURIComponent(query.continue as string) : ''
      }`
    );
  };

  return (
    <MessageDialog
      primaryBtnLabel={data?.modal_button_text ?? 'Xác thực'}
      secondaryBtnLabel="Trở về"
      open={open}
      onClose={onClose}
      onPrimaryButtonClick={goVerifyOTP}
      onSecondaryButtonClick={onClose}
      contentTitle={data?.modal_header ?? 'Phát hiện đăng nhập tài khoản trên thiết bị mới'}
      contentDescription={
        data?.modal_body ??
        '<p>Vì lý do bảo mật, vui lòng xác thực OTP để đăng nhập vào tài khoản.</p>'
      }
      status="warning"
      isHtmlDescription
    />
  );
};

export default VerifyOTPPopup;
